function splitPath(str){
    return str.split("/").slice(1); //Slice because the slash produces an empty first item
}
function setActiveNav(path){ //Use with .call(array, path)
    path = splitPath(path);
    //Ensure the array always has three entries
    path[1] = path[1] || undefined;
    path[2] = path[2] || undefined;

    for(let i = 0, len = navStructure.length; i < len; i++){
        let key = navStructure[i];
        let nav = this[key];
        let result = -1;
        if(path[i]){
            result = nav.items.find(item => item.PathTag === path[i]);
            result = result[`${key}Key`]; //e.g. TOCkey, SegmentKey, ContentKey
        }
        nav.active = result;
    }
}
function hashURLs(){
    let obj = {};
    for(let i = 0, len = navStructure.length; i < len; i++){
        let key = navStructure[i];
        let nav = this[key];
        for(let j = 0, limit = nav.items.length; j < limit; j++){
            let k = nav.items[j].Path;
            if(!obj.hasOwnProperty(k)){
                obj[k] = true;
            }
        }
    }
    return obj;
}
let navStructure = ["TOC","Segment","Content"];
let obj = {
    app:{
        loaded: false,
        refreshed: false,
        mode: false,
        error: false,
        landingPath: false
    },
    config:{},
    nav:{
        raw:{},
        urls:{},
        TOC:{
            items:[],
            active: -1
        },
        Segment:{
            items:[],
            active: -1
        },
        Content:{
            items:[],
            active: -1
        },
    },
    // eslint-disable-next-line
    digest(path, q_params){
        if(this.nav.urls[path]){
            setActiveNav.call(this.nav, path);
            return true;
        }
        return false;
    },
    bootstrap(o, force){
        if(!this.app.refreshed || force){
            this.nav.raw = Object.assign(o,{});
            this.nav.TOC.items = o.TOC;
            this.nav.Segment.items = o.Segment;
            this.nav.Content.items = o.Content;
            this.nav.urls = hashURLs.call(this.nav);
            
            this.app.loaded = true;
        }
    }
};

Object.defineProperty(obj.nav.TOC, "current", {
    get(){
        let TOC = obj.nav.TOC.items.filter(item => item.TOCKey === obj.nav.TOC.active);
        return TOC;
    }
});

Object.defineProperty(obj.nav.Segment, "current", {
    get(){
        let segment = obj.nav.Segment.items.filter(item => item.TOCKey === obj.nav.TOC.active);
        return segment;
    }
});

export default obj;